
import { defineComponent } from "vue";

import BreadCrumb from "../../components/Common/BreadCrumb.vue";
import PreschoolReportScoreContent from './Components/PreschoolReportScoreContent.vue';

export default defineComponent({
    name: "PreschoolReportScoreContentPage",
    components: {
        BreadCrumb,
        PreschoolReportScoreContent
    },
});
